import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FaRegTrashAlt, FaCog, FaFilter } from 'react-icons/fa';
import Button from '../../elements/Button';
import ToggleButton from '../../elements/ToggleButton';
import ToolTip from '../../elements/ToolTip/ToolTip';
import PanelHeader from './PanelHeader';
const styles = {
    leftContainer: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
    },
    counterLabel: {
        margin: 0,
        textAlign: 'right',
        lineHeight: '22px',
        padding: '0 10px',
        whiteSpace: 'nowrap',
    },
};
function DefaultPanelHeader({ counter, onDelete = () => null, deleteToolTip = 'Delete', onFilter = () => null, filterToolTip = '', filterIsActive = false, counterFiltered = 0, children, onSettingClick = () => null, showSettingButton = false, canDelete = true, disableDelete = false, style = {}, className = '', renderRightButtons, }) {
    return (_jsxs(PanelHeader, { style, className, children: [_jsxs("div", { style: styles.leftContainer, children: [canDelete && (_jsx(Button.BarButton, { color: { base: 'black', hover: 'red' }, onClick: onDelete, disabled: counter === 0 || disableDelete, toolTip: deleteToolTip, tooltipOrientation: "horizontal", children: _jsx(FaRegTrashAlt, {}) })), filterToolTip ? (_jsx(ToggleButton, { popupTitle: filterToolTip, popupPlacement: "right", onClick: onFilter, defaultValue: filterIsActive, children: _jsx(FaFilter, { style: { pointerEvents: 'none', fontSize: '12px' } }) })) : null, children] }), renderRightButtons?.(), counter !== undefined && (_jsxs("p", { style: styles.counterLabel, children: ["[", ' ', filterIsActive && counterFiltered !== undefined
                        ? `${counterFiltered}/${counter}`
                        : counter, ' ', "]"] })), showSettingButton && (_jsx(ToolTip, { title: "Preferences", popupPlacement: "left", children: _jsx("button", { type: "button", onClick: onSettingClick, children: _jsx(FaCog, {}) }) }))] }));
}
export default DefaultPanelHeader;
